import {
  CONTENT_CLASSNAME,
  LINK_CLASSNAME,
} from '@/app/lcv/components/sections/news-activities/details/content-rows/constants';
import { cn } from '@/app/utils/cn';
import { buildHtmlMarkup } from '@/app/utils/html/html';
import type { ComponentNewsTextContent } from '@/types/tis-cms/types';

export const TextContent = ({ data }: { data: ComponentNewsTextContent }) => (
  <div
    className={cn(
      'text-body-1 text-gray-700',
      CONTENT_CLASSNAME,
      LINK_CLASSNAME
    )}
    dangerouslySetInnerHTML={buildHtmlMarkup(data.textContent)}
  />
);
